import React, { FC } from 'react';
import TransparentButton from '../../shared/transparent-button/transparent-button';
import { PollResultsShareContent } from '../../../constans/polls-constants';

interface IProps {
  resultsShared: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const ShowResultsButton: FC<IProps> = ({ resultsShared, disabled, onClick }): JSX.Element => (
  <TransparentButton customClasses={`result-slide ${resultsShared ? 'result-slide-shared' : ''}`} disabled={disabled} onClick={onClick}>
    {resultsShared ? PollResultsShareContent.HIDE_RESULTS : PollResultsShareContent.SHOW_RESULTS}
  </TransparentButton>
);

export default ShowResultsButton;
